import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { landingRedirectGuard } from './guards/landing-redirect.guard';
import { LayoutComponent } from './layouts/app-layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [landingRedirectGuard],
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'magic-confirm',
    loadComponent: () => import('./pages/magic-confirm/magic-confirm.component').then(m => m.MagicConfirmComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    component: LayoutComponent,
    data: {
      shell: 'app'
    },
    children: [
      {
        path: 'dashboard',
        data: {
          shell: 'app',
          section: 'dashboard'
        },
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'profile',
        data: {
          shell: 'app',
          section: 'profile'
        },
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'notifications',
        data: {
          shell: 'app',
          section: 'notifications'
        },
        loadChildren: () => import('./features/notifications/notifications.routes').then(m => m.NOTIFICATIONS_ROUTES)
      },
      {
        path: 'messages',
        data: {
          shell: 'app',
          section: 'messages',
          titleKey: 'pages.dashboard.cards.common.messages.title'
        },
        loadComponent: () => import('./pages/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent)
      },
      {
        path: 'admin/users',
        data: {
          shell: 'app',
          section: 'admin-users'
        },
        loadComponent: () => import('./pages/admin/users/users-list.component').then(m => m.UsersListComponent)
      },
      {
        path: 'admin/payments',
        data: {
          shell: 'app',
          section: 'admin-payments'
        },
        loadComponent: () => import('./pages/admin/payments/payments-list.component').then(m => m.PaymentsListComponent)
      },
      {
        path: 'admin/sponsors',
        data: {
          shell: 'app',
          section: 'admin-sponsors'
        },
        loadComponent: () => import('./pages/admin/sponsors/sponsors-list.component').then(m => m.SponsorsListComponent)
      },
      {
        path: 'admin/branches',
        data: {
          shell: 'app',
          section: 'admin-branches'
        },
        loadComponent: () => import('./pages/admin/branches/branches-list.component').then(m => m.BranchesListComponent)
      },
      {
        path: 'admin/sections',
        data: {
          shell: 'app',
          section: 'admin-sections'
        },
        loadComponent: () => import('./pages/admin/sections/sections-list.component').then(m => m.SectionsListComponent)
      },
      {
        path: 'admin/training-groups',
        data: {
          shell: 'app',
          section: 'admin-training-groups'
        },
        loadComponent: () => import('./pages/admin/training-groups/training-groups-list.component').then(m => m.TrainingGroupsListComponent)
      },
      {
        path: 'admin/assignments',
        data: {
          shell: 'app',
          section: 'admin-assignments'
        },
        loadChildren: () => import('./features/assignments/assignments.routes').then(m => m.ADMIN_ASSIGNMENTS_ROUTES)
      },
      {
        path: 'admin/sessions',
        data: {
          shell: 'app',
          section: 'admin-sessions'
        },
        loadChildren: () =>
          import('./features/training-sessions/training-sessions.routes').then((m) => m.ADMIN_TRAINING_SESSIONS_ROUTES)
      },
      {
        path: 'admin/series',
        data: {
          shell: 'app',
          section: 'admin-series'
        },
        loadChildren: () =>
          import('./features/training-sessions/training-sessions.routes').then((m) => m.ADMIN_TRAINING_SERIES_ROUTES)
      },
      {
        path: 'admin/notifications/broadcast',
        data: {
          shell: 'app',
          section: 'admin-notifications-broadcast'
        },
        loadComponent: () => import('./pages/admin/notifications/notifications-broadcast.component').then(m => m.NotificationsBroadcastComponent)
      },
      {
        path: 'admin/facilities',
        data: {
          shell: 'app',
          section: 'admin-facilities'
        },
        loadChildren: () => import('./features/facilities/facilities.routes').then(m => m.FACILITIES_ROUTES)
      },
      {
        path: 'admin/attendance',
        data: {
          shell: 'app',
          section: 'admin-attendance',
          breadcrumb: 'pages.admin.attendance.title'
        },
        loadComponent: () => import('./pages/admin/attendance/attendance-list.component').then(m => m.AttendanceListComponent)
      },
      {
        path: 'admin/settings',
        data: {
          shell: 'app',
          section: 'admin-settings',
          titleKey: 'pages.dashboard.cards.admin.settings.title'
        },
        loadComponent: () => import('./pages/admin/settings/admin-settings.component').then(m => m.AdminSettingsComponent)
      },
      {
        path: 'admin/reports',
        data: {
          shell: 'app',
          section: 'admin-reports',
          titleKey: 'pages.admin.reports.title'
        },
        loadComponent: () => import('./pages/admin/reports/admin-reports.component').then(m => m.AdminReportsComponent)
      },
      {
        path: 'admin/injuries',
        data: {
          shell: 'app',
          section: 'admin-injuries',
          titleKey: 'pages.admin.injuries.title'
        },
        loadComponent: () => import('./pages/admin/injuries/admin-injuries.component').then(m => m.AdminInjuriesComponent)
      },
      {
        path: 'admin/legal-guardians',
        data: {
          shell: 'app',
          section: 'admin-legal-guardians',
          titleKey: 'pages.admin.legal_guardians.title'
        },
        loadComponent: () => import('./pages/admin/legal-guardians/admin-legal-guardians.component').then(m => m.AdminLegalGuardiansComponent)
      },
      {
        path: 'admin/players/:id',
        data: {
          shell: 'app',
          section: 'admin-player-profile',
          titleKey: 'pages.admin.player_profile.title'
        },
        loadComponent: () => import('./pages/admin/players/admin-player-profile.component').then(m => m.AdminPlayerProfileComponent)
      },
      {
        path: 'teams',
        data: {
          shell: 'app',
          section: 'teams',
          titleKey: 'pages.dashboard.cards.common.teams.title'
        },
        loadComponent: () => import('./pages/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent)
      },
      {
        path: 'coach/attendance',
        data: {
          shell: 'app',
          section: 'coach-attendance',
          titleKey: 'pages.coach.attendance.title',
          breadcrumb: 'pages.coach.attendance.title'
        },
        loadComponent: () => import('./pages/coach/attendance/coach-attendance.component').then(m => m.CoachAttendanceComponent)
      },
      {
        path: 'coach/schedule',
        data: {
          shell: 'app',
          section: 'coach-schedule',
          titleKey: 'pages.dashboard.cards.coach.training.title'
        },
        loadComponent: () =>
          import('./features/training-sessions/pages/coach-schedule/coach-schedule.component').then(
            (m) => m.CoachScheduleComponent
          )
      },
      {
        path: 'coach/sessions',
        data: {
          shell: 'app',
          section: 'coach-sessions',
          titleKey: 'pages.dashboard.cards.coach.training.title'
        },
        loadChildren: () =>
          import('./features/training-sessions/training-sessions.routes').then((m) => m.COACH_TRAINING_SESSIONS_ROUTES)
      },
      {
        path: 'coach/series',
        data: {
          shell: 'app',
          section: 'coach-series'
        },
        loadChildren: () =>
          import('./features/training-sessions/training-sessions.routes').then((m) => m.COACH_TRAINING_SERIES_ROUTES)
      },
      {
        path: 'coach/training',
        redirectTo: 'coach/schedule',
        pathMatch: 'full'
      },
      {
        path: 'coach/athletes',
        data: {
          shell: 'app',
          section: 'coach-athletes',
          titleKey: 'pages.dashboard.cards.coach.athletes.title'
        },
        loadChildren: () => import('./features/assignments/assignments.routes').then(m => m.COACH_ATHLETES_ROUTES)
      },
      {
        path: 'coach/groups',
        data: {
          shell: 'app',
          section: 'coach-groups',
          titleKey: 'pages.dashboard.cards.coach.groups.title'
        },
        loadComponent: () => import('./pages/coach/groups/coach-groups.component').then(m => m.CoachGroupsComponent)
      },
      {
        path: 'coach/players',
        data: {
          shell: 'app',
          section: 'coach-players',
          titleKey: 'pages.coach.players.title',
          breadcrumb: 'pages.coach.players.title'
        },
        loadComponent: () => import('./pages/coach/players/coach-players.component').then(m => m.CoachPlayersComponent)
      },
      {
        path: 'parent/children',
        data: {
          shell: 'app',
          section: 'parent-children',
          titleKey: 'pages.dashboard.cards.parent.children.title'
        },
        loadComponent: () => import('./pages/parent/children/parent-children.component').then(m => m.ParentChildrenComponent)
      },
      {
        path: 'parent/payments',
        data: {
          shell: 'app',
          section: 'parent-payments',
          titleKey: 'pages.dashboard.cards.parent.payments.title'
        },
        loadComponent: () => import('./pages/parent/payments/parent-payments.component').then(m => m.ParentPaymentsComponent)
      },
      {
        path: 'parent/documents',
        data: {
          shell: 'app',
          section: 'parent-documents',
          titleKey: 'pages.dashboard.cards.parent.docs.title'
        },
        loadComponent: () => import('./pages/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent)
      },
      {
        path: 'player/profile',
        data: {
          shell: 'app',
          section: 'player-profile',
          titleKey: 'pages.profile.title'
        },
        loadComponent: () => import('./pages/player/profile/player-profile.component').then(m => m.PlayerProfileComponent)
      },
      {
        path: 'player/coaches',
        data: {
          shell: 'app',
          section: 'player-coaches',
          titleKey: 'pages.dashboard.cards.player.coaches.title'
        },
        loadChildren: () => import('./features/assignments/assignments.routes').then(m => m.PLAYER_COACHES_ROUTES)
      },
      {
        path: 'player/schedule',
        data: {
          shell: 'app',
          section: 'player-schedule',
          titleKey: 'pages.dashboard.cards.player.schedule.title'
        },
        loadComponent: () =>
          import('./features/training-sessions/pages/player-schedule/player-schedule.component').then(
            (m) => m.PlayerScheduleComponent
          )
      },
      {
        path: 'player/sessions',
        data: {
          shell: 'app',
          section: 'player-sessions',
          titleKey: 'pages.dashboard.cards.player.schedule.title'
        },
        loadChildren: () =>
          import('./features/training-sessions/training-sessions.routes').then((m) => m.PLAYER_TRAINING_SESSIONS_ROUTES)
      },
      {
        path: 'player/groups',
        data: {
          shell: 'app',
          section: 'player-groups',
          titleKey: 'pages.dashboard.cards.player.groups.title'
        },
        loadComponent: () => import('./pages/player/groups/player-groups.component').then(m => m.PlayerGroupsComponent)
      },
      {
        path: 'player/attendance',
        data: {
          shell: 'app',
          section: 'player-attendance',
          titleKey: 'pages.dashboard.cards.player.attendance.title'
        },
        loadComponent: () => import('./pages/player/attendance/player-attendance.component').then(m => m.PlayerAttendanceComponent)
      },
      {
        path: 'player/injuries',
        data: {
          shell: 'app',
          section: 'player-injuries',
          titleKey: 'pages.dashboard.cards.player.injuries.title'
        },
        loadComponent: () => import('./pages/player/injuries/player-injuries.component').then(m => m.PlayerInjuriesComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '',
  },
];
